export const formatPrice = (price, isPriceFrom = false) => {
	return (isPriceFrom ? 'od\xa0' : '') + (Number(price) === -1 ? 'individuálně' : (Number(price).toLocaleString('cs') + '\xa0Kč'));
}

export const notePrice = price => {
	return price ? (' (' + (Math.sign(price) === 1 ? '+' : '') + formatPrice(price) + ')') : '';
}

export const getPositiveOrNull = number => number !== -1 ? number : null;

export const getValueFromMap = (map, searchValue, nullIfNotFount = false) => {
	const item = map.map(row => ({
		from: row.from === -1 ? -Infinity : row.from,
		to: row.to === -1 ? Infinity : row.to,
		value: row.value
	}))
		.find(item => item.from <= searchValue && item.to >= searchValue);
	return item ? item.value : nullIfNotFount ? null : -1;
}

export const stripTags = (string) => {
	return string.replace(/<\/?[^>]+(>|$)/g, '');
}

export function debounce(callback, wait) {
	let timeout;
	return (...args) => {
		const context = this;
		clearTimeout(timeout);
		timeout = setTimeout(() => callback.apply(context, args), wait);
	};
}

export function convertToTextResult(result, discount, gift, amountSaved) {
	const textResult = {...result};

	if (discount && discount.code != null)  {
		let value = 
		discount.fixedDiscount ? (discount.fixedDiscount ? "" : '-' + formatPrice(discount.fixedDiscount)) :  
		('-' + (discount.fixedDiscount ? formatPrice(discount.fixedDiscount) : discount.discount + ' %'))
		textResult["discount"] = {
			"label": "Slevový kód: " + discount.title,
			"mainValue": value,
			"parts": [],
			"zone": "Slevový kód",
			"originPrice": null,
			"price": (discount.fixedDiscount ? (-1 * discount.fixedDiscount) : (-1 * amountSaved)),
			"finalPercentage": null,
			"frequency": null,
			"isPriceFrom": false,
			"customerNotePrompt": null,
			"customerNote": null,
			"image": null
		};
	}

	if (gift) {
		textResult["gift"] = {
			"label": gift.title,
			"mainValue": "",
			"parts": [],
			"zone": "Dárek",
			"originPrice": null,
			"price": -2,
			"finalPercentage": null,
			"frequency": null,
			"isPriceFrom": false,
			"customerNotePrompt": null,
			"customerNote": null,
			"image": gift.image?.thumbnail
		};
	}

	return JSON.stringify(textResult);
}